export enum PatternType {
  REST_ZONE_PATTERNS,
  FREE_ZONE_PATTERNS,
  JUTE_PATTERNS,
  JUTE_PATTERNS_OR_DRAWINGS,
  WEAVE_PATTERNS_OR_DRAWINGS,
  CUTBAR_PATTERNS,
  FOLDING_TYPES_PATTERNS
}
